import PropTypes from 'prop-types';
import {useEffect} from 'react';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
// hooks
import {useResponsive} from 'packages/common/hooks/useResponsive';
// components
import Scrollbar from 'packages/common/components/scrollbar';
import {usePathname} from 'packages/common/routes/hooks';
import {NavSectionVertical} from 'packages/common/components/nav-section';
// theme
import {ADMIN_PALETTE} from 'packages/common/theme/admin';
//
import {NAV} from '../config-layout';
import {useNavData} from './config-navigation';
import {NavToggleButton} from '../_common-admin';
import NavAccountSection from './nav-account-section';

// ----------------------------------------------------------------------

export default function NavVertical({openNav, onCloseNav}) {
  const pathname = usePathname();

  const lgUp = useResponsive('up', 'lg');

  const navData = useNavData();

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      sx={{
        'height': 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box
        component="img"
        src="/logo/logo_full_white.svg"
        sx={{
          width: 140,
          height: 64,
          mt: 3,
          ml: 4,
          mb: 1,
          cursor: 'pointer',
        }}
      />

      <NavSectionVertical
        data={navData}
      />

      <Box sx={{flexGrow: 1}} />

      <NavAccountSection />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: {lg: 0},
        width: {lg: NAV.W_VERTICAL},
      }}
    >
      <NavToggleButton />

      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: 'fixed',
            width: NAV.W_VERTICAL,
            bgcolor: ADMIN_PALETTE.nav.background,
            borderRight: `1px solid ${ADMIN_PALETTE.nav.border}`,
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <>
          <Drawer
            open={openNav}
            onClose={onCloseNav}
            PaperProps={{
              sx: {
                width: NAV.W_VERTICAL,
                bgcolor: ADMIN_PALETTE.nav.background,
                backgroundImage: 'none',
              },
            }}
            sx={{
              '& .MuiDrawer-paper': {
                bgcolor: ADMIN_PALETTE.nav.background,
                backgroundImage: 'none',
              },
            }}
          >
            <Box sx={{height: '100%', bgcolor: ADMIN_PALETTE.nav.background}}>{renderContent}</Box>
          </Drawer>
        </>
      )}
    </Box>
  );
}

NavVertical.propTypes = {
  onCloseNav: PropTypes.func,
  openNav: PropTypes.bool,
};
